import Container from 'react-bootstrap/Container';
import AppsGetAll from '../services/AppsGetAll';

function Apps() {
  return (
    <div>
      <Container>
        <AppsGetAll />
      </Container>
    </div>
  );
}

export default Apps;